module.exports = __webpack_public_path__ + "img/bybit_600rewards_730x90.fbbdb173.png";